<script setup lang="ts"></script>

<template>
  <img
    src="https://cdn.ccli.com/songselect/vue/youtube-logo.svg"
    :alt="$t('SV.LIT_YoutubeLogo')"
    class="img"
  />
</template>

<style scoped lang="postcss">
.img {
  filter: contrast(500%) invert(100%) grayscale(100%);
  width: 80px;
  height: 18px;
  display: block;
}
</style>
